module.exports = __webpack_public_path__ + "static/media/nlg-logo.7a7183f8.png";